import { useState } from "react";
import { Input } from "@/components/ui/input";
import { isCanonicalUnit, unitGroupsFor } from "@/lib/parameter-units";

interface UnitDropdownProps {
  category: "NUMERIC" | "COUNTER" | "DURATION";
  value: string;
  onChange: (value: string) => void;
  id?: string;
}

const CUSTOM_SENTINEL = "__custom__";
const UNIT_INPUT_PATTERN = "[A-Za-zÀ-ÿ0-9°²³⁴⁵⁶⁷⁸⁹/·µ%·.\\- ]{1,20}";

export function UnitDropdown({ category, value, onChange, id }: UnitDropdownProps) {
  const groups = unitGroupsFor(category);
  const valueIsCanonical = value === "" || isCanonicalUnit(category, value);
  const [mode, setMode] = useState<"canonical" | "custom">(
    valueIsCanonical ? "canonical" : "custom"
  );

  function handleSelectChange(e: React.ChangeEvent<HTMLSelectElement>) {
    if (e.target.value === CUSTOM_SENTINEL) {
      setMode("custom");
      onChange("");
      return;
    }
    setMode("canonical");
    onChange(e.target.value);
  }

  if (mode === "custom") {
    return (
      <div className="space-y-1">
        <Input
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="ex.: cP, lm, dBA"
          maxLength={20}
          pattern={UNIT_INPUT_PATTERN}
        />
        <button
          type="button"
          className="text-[10px] text-muted-foreground underline hover:text-foreground"
          onClick={() => {
            setMode("canonical");
            onChange("");
          }}
        >
          Voltar para unidades padrão
        </button>
      </div>
    );
  }

  return (
    <select
      id={id}
      value={value}
      onChange={handleSelectChange}
      className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm"
    >
      <option value="" disabled>
        Selecione…
      </option>
      {groups.map((group) => (
        <optgroup key={group.label} label={group.label}>
          {group.units.map((u) => (
            <option key={u} value={u}>
              {u}
            </option>
          ))}
        </optgroup>
      ))}
      <optgroup label="—">
        <option value={CUSTOM_SENTINEL}>Outra…</option>
      </optgroup>
    </select>
  );
}
